export default function processEventosEChamados(eventos = [], chamados = []) {
    // Verificação de dados
    if (!Array.isArray(eventos) || !Array.isArray(chamados)) {
        console.error("Dados inválidos: eventos ou chamados não são arrays");
        return eventos.map(e => ({...e, chamado_status: "Ocorrência"}));
    }

    // Cria um mapa para acessar chamados por id_registro_inicial ou id_registro_final
    const chamadosMap = new Map();
    chamados.forEach(chamado => {
        if (chamado.id_registro_inicial) {
            chamadosMap.set(chamado.id_registro_inicial.toString(), chamado);
        }
        if (chamado.id_registro_final) {
            chamadosMap.set(chamado.id_registro_final.toString(), chamado);
        }
    });

    // Processa cada evento
    return eventos.map(evento => {
        // Tipo Anticarona sempre tem status "Ocorrência"
        if (evento.tipo === "Anticarona") {
            return { ...evento, chamado_status: "Ocorrência" };
        }

        // Verifica se existe um chamado para este evento usando o mapa
        const eventoId = evento.id.toString();
        const chamadoAssociado = chamadosMap.get(eventoId);
        
        if (chamadoAssociado) {
            // Determina o status do chamado
            let chamadoStatus = "Desconhecido";
            
            if (chamadoAssociado.status === "concluído") {
                chamadoStatus = chamadoAssociado.solucao ? "Concluído" : "Concluído/Pendente";
            } else if (chamadoAssociado.status === "aberto") {
                chamadoStatus = "Pendente";
            } else if (chamadoAssociado.status === "em andamento") {
                chamadoStatus = "Em andamento";
            } else {
                chamadoStatus = chamadoAssociado.status || "Desconhecido";
            }
            
            // Retorna o evento com informações do chamado
            return {
                ...evento,
                chamado_status: chamadoStatus,
                chamado_detalhes: chamadoAssociado,
            };
        } else {
            // Sem chamado associado
            return { ...evento, chamado_status: "Ocorrência" };
        }
    });
}